// @ts-nocheck
import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Grid,
  TextField,
  Typography,
  Input,
  FormControl,
  Select,
  MenuItem,
  SelectChangeEvent,
} from "@mui/material";
import MainContainer from "../../layout/MainContainer";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import CancelIcon from "@mui/icons-material/Cancel";
import { ChangeEvent, useEffect, useState } from "react";
import useTranslation from "../../hooks/Translation";
import {
  useLazyGetCategoryByIdQuery,
  useUpdateCategoryMutation,
} from "../../services/main";
import { showError, showToast } from "../../constants";
import * as Yup from "yup";
import { isString, useFormik } from "formik";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody } from "../../types/General";
import { UploadMedia } from "../../utils/mediaUpload";
import { resolveMediaUrl } from "../../utils/mediaUrl";
import {
  ARABIC_FIELD_CLASS,
  arabicInputProps,
} from "../../utils/arabicField";

const EditCategories = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const { id } = useParams();
  const [getCategoryDetails] = useLazyGetCategoryByIdQuery();
  const [updateCategory] = useUpdateCategoryMutation();
  const [category, setCategory] = useState<string>("");
  const [categoryById, setCategoryById] = useState<any>();
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState(0);
  const [image, setImage] = useState<string>("");
  const [fileName, setFileName] = useState<string>("");
  const [isLoading2, setIsLoading2] = useState(false);

  const handleImageUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target;
    const file = files?.files?.length ? files?.files[0] : "";
    setIsLoading2(true);
    const res = await UploadMedia(file);
    if (res?.statusCode === 200) {
      setImage(res?.data);
    } else {
      showError(res?.message);
    }
    setIsLoading2(false);
  };
  const translate = useTranslation();
  const handleCategoryChange = (event: SelectChangeEvent) => {
    setCategory(event.target.value as string);
  };

  const getCategoryDetail = async (id: string | undefined) => {
    try {
      const res = await getCategoryDetails({ categoryId: id }).unwrap();
      if (res?.statusCode === 200) {
        setCategoryById(res?.data);
        setImage(res?.data?.image);
      }
    } catch (error: any) {
      console.log(error, "errror");
      showError(error?.data?.message || "");
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: categoryById?.name || "",
      title_ar: categoryById?.name_ar || "",
    },
    validationSchema: Yup.object({
      title: Yup.string()
        .required(translate?.error?.required || "")
        .max(15, translate?.error?.maxValidation15 || "")
        .min(2, translate?.error?.minValidation2 || ""),
      title_ar: Yup.string()
        .required(translate?.error?.required || "")
        .max(15, translate?.error?.maxValidation15 || "")
        .min(2, translate?.error?.minValidation2 || ""),
    }),
    onSubmit: async () => {
      formik.setSubmitting(true);

      const data = {
        name: formik?.values?.title,
        name_ar: formik?.values?.title_ar,
        image: image,
      };

      if (id && id !== "add") {
        try {
          let encryptedBody = generateEncryptedKeyBody(data) as CommonBody;
          const response = await updateCategory({
            userId: id,
            encryptedBody,
          }).unwrap();
          if (response?.statusCode === 200) {
            showToast(translate?.error?.catUpdate || "");
            navigate("/manage-categories");
          } else {
            showError(response?.message || "");
          }
        } catch (error: any) {
          showError(error?.data?.message || "");
          console.log(error);
        }
      } else {
        try {
          let encryptedBody = generateEncryptedKeyBody(data) as CommonBody;
          const response = await updateCategory({
            userId: id,
            encryptedBody,
          }).unwrap();
          if (response?.statusCode === 200) {
            showToast(translate?.error?.subCatAdd || "");
            formik.resetForm();
            navigate("/manage-categories");
          } else {
            showError(response?.message || "");
          }
        } catch (error: any) {
          showError(error?.data?.message || "");
          console.log(error);
        }
      }
    },
  });

  useEffect(() => {
    getCategoryDetail(id);
  }, []);

  return (
    <>
      <MainContainer>
        <div className="main_loyout">
          <div className="dashboard">
            <h1>{translate?.main?.editCategory}</h1>
            <Button
              className="btn btn_primary"
              onClick={() => {
                navigate("/manage-categories");
              }}
            >
              {translate?.main?.Back}
            </Button>
          </div>
          <Card className="cards">
            <form onSubmit={formik.handleSubmit}>
              <CardContent sx={{ p: 1 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography className="custom_label">{translate?.main?.Image}</Typography>
                    {image ? (
                      <div className="upload_image_preview category_icon_upload">
                        <CardMedia
                          component="img"
                          image={resolveMediaUrl(image) || image}
                          alt="photo"
                          sx={{
                            backgroundColor: "transparent",
                            background: "transparent",
                          }}
                        />
                        <CancelIcon onClick={() => setImage("")} />
                      </div>
                    ) : (
                      <Box className="upload_image">
                        <label htmlFor="edit-icon-button-file">
                          <Input
                            sx={{ display: "none" }}
                            id="edit-icon-button-file"
                            type="file"
                            inputProps={{ accept: "image/png,image/jpeg" }}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                              handleImageUpload(e)
                            }
                          />
                          <Button
                            component="span"
                            className="upload_image_btn category_icon_upload"
                          >
                            <span className="category_icon_placeholder">
                              <CameraAltIcon />
                            </span>
                          </Button>
                        </label>
                      </Box>
                    )}
                  </Grid>
                  {state === "GOAL" ? (
                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <Typography className="custom_label">
                        {translate?.main?.selectCat}
                      </Typography>
                      <FormControl sx={{ width: "100%" }}>
                        <Select
                          className="select_div"
                          fullWidth
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={category}
                          inputProps={{
                            "aria-label": "Without label",
                          }}
                          displayEmpty
                          onChange={handleCategoryChange}
                        >
                          <MenuItem value="" disabled>
                            {translate?.dashboard?.Select}
                          </MenuItem>
                          <MenuItem value="cat1">Category 1</MenuItem>
                          <MenuItem value="cat2">Category 2</MenuItem>
                          <MenuItem value="cat3">Category 3</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  ) : null}
                  {state === "GOAL" ? (
                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <Typography className="custom_label">
                        {translate?.main?.subCatName}
                      </Typography>
                      <TextField
                        hiddenLabel
                        type={"text"}
                        name="title"
                        variant="outlined"
                        fullWidth
                        placeholder={translate?.main?.subCatName || ""}
                      />
                    </Grid>
                  ) : (
                    <>
                      <Grid item lg={4} md={4} sm={6} xs={12}>
                        <Typography className="custom_label">
                          {translate?.main?.categoryNameEn}
                        </Typography>
                        <TextField
                          hiddenLabel
                          type={"text"}
                          name="title"
                          variant="outlined"
                          value={formik.values.title}
                          fullWidth
                          placeholder={translate?.main?.CategoryName || ""}
                          inputProps={{ maxLength: 15 }}
                          onBlur={formik.handleBlur}
                          onChange={(val) => {
                            if (
                              val.target.value === " " ||
                              val.target.value === "."
                            ) {
                            } else {
                              formik.handleChange(val);
                            }
                          }}
                          helperText={
                            formik.touched.title && formik.errors.title
                          }
                        />
                      </Grid>
                      <Grid item lg={4} md={4} sm={6} xs={12}>
                        <Typography className="custom_label">
                          {translate?.main?.categoryNameAr}
                        </Typography>
                        <TextField
                          hiddenLabel
                          type={"text"}
                          name="title_ar"
                          variant="outlined"
                          fullWidth
                          className={ARABIC_FIELD_CLASS}
                          inputProps={{ ...arabicInputProps, maxLength: 15 }}
                          placeholder={translate?.main?.CategoryName || ""}
                          onBlur={formik.handleBlur}
                          value={formik.values.title_ar}
                          onChange={(val) => {
                            if (
                              val.target.value === " " ||
                              val.target.value === "."
                            ) {
                            } else {
                              formik.handleChange(val);
                            }
                          }}
                          helperText={
                            formik.touched.title_ar && formik.errors.title_ar
                          }
                        />
                      </Grid>
                    </>
                  )}
                </Grid>
                <div className="form_btn">
                  <Button
                    size="large"
                    type="submit"
                    className="btn btn_primary"
                  >
                    {translate?.main?.Save}
                  </Button>
                </div>
              </CardContent>
            </form>
          </Card>
        </div>
      </MainContainer>
    </>
  );
};

export default EditCategories;
